const BASE_URL = '/internalApi/v2/sales-activity/';

export const SALES_ACTIVITY_URLS = {
  GET: BASE_URL + 'history/',
  COMMENT: BASE_URL + 'comment/',
  REACT: BASE_URL + 'react/',
};
